/** Deterministic 32-bit hashing (MurmurHash3-style mixing). The only source of "randomness" in the project. */
export type HashKey = number | string;

function mix(h: number, k: number): number {
  k = Math.imul(k, 0xcc9e2d51);
  k = (k << 15) | (k >>> 17);
  k = Math.imul(k, 0x1b873593);
  h ^= k;
  h = (h << 13) | (h >>> 19);
  return (Math.imul(h, 5) + 0xe6546b64) | 0;
}

function finalize(h: number): number {
  h ^= h >>> 16;
  h = Math.imul(h, 0x85ebca6b);
  h ^= h >>> 13;
  h = Math.imul(h, 0xc2b2ae35);
  h ^= h >>> 16;
  return h >>> 0;
}

const f64 = new DataView(new ArrayBuffer(8));

function words(key: HashKey): number[] {
  if (typeof key === 'number') {
    if (Number.isInteger(key) && Math.abs(key) <= 0x7fffffff) return [0x6e756d, key | 0];
    f64.setFloat64(0, key);
    return [0x666c74, f64.getInt32(0), f64.getInt32(4)];
  }
  const out = [0x737472, key.length];
  for (let i = 0; i < key.length; i++) out.push(key.charCodeAt(i));
  return out;
}

export function hash(seed: number, ...keys: HashKey[]): number {
  let h = seed | 0;
  for (const key of keys) for (const w of words(key)) h = mix(h, w);
  return finalize(h ^ keys.length);
}

export function hash01(seed: number, ...keys: HashKey[]): number {
  return hash(seed, ...keys) / 4294967296;
}
